import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Lock } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { login } from "@/lib/api";

export default function Login() {
    const [username, setUsername] = useState("admin");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(username, password);
            toast.success("تم تسجيل الدخول بنجاح");
            navigate("/");
        } catch (err) {
            toast.error(
                err?.response?.data?.detail || "فشل تسجيل الدخول",
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="flex min-h-screen items-center justify-center px-4 noise-overlay"
            dir="rtl"
        >
            <div
                className="absolute inset-0 -z-10 bg-[radial-gradient(900px_circle_at_50%_-10%,rgba(34,211,238,0.10),transparent_60%)]"
                aria-hidden
            />
            <Card className="w-full max-w-md border-border/60 bg-card/60 backdrop-blur-xl">
                <CardContent className="p-6 md:p-8">
                    <div className="mb-6 text-center">
                        <div className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-cyan-500/30 bg-gradient-to-br from-cyan-500/15 to-emerald-500/15">
                            <ShieldCheck className="h-7 w-7 text-cyan-300" />
                        </div>
                        <h1 className="mt-4 text-2xl font-semibold tracking-tight">
                            Guardian Pro
                        </h1>
                        <p className="mt-1 text-sm text-muted-foreground">
                            مركز التحكم بحماية تلغرام الاحترافية
                        </p>
                    </div>

                    <form onSubmit={onSubmit} className="space-y-4">
                        <div>
                            <Label htmlFor="username" className="text-sm">
                                اسم المستخدم
                            </Label>
                            <Input
                                id="username"
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="admin"
                                autoComplete="username"
                                className="mt-1.5"
                                data-testid="login-username-input"
                                required
                            />
                        </div>
                        <div>
                            <Label htmlFor="password" className="text-sm">
                                كلمة المرور
                            </Label>
                            <Input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                autoComplete="current-password"
                                className="mt-1.5"
                                data-testid="login-password-input"
                                required
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={loading}
                            className="w-full gap-2"
                            data-testid="login-submit-button"
                        >
                            <Lock className="h-4 w-4" />
                            {loading ? "التحقق..." : "تسجيل الدخول"}
                        </Button>
                    </form>

                    <div className="mt-6 rounded-lg border border-border/60 bg-muted/30 p-3 text-center">
                        <p className="text-[11px] text-muted-foreground">
                            دخول الفحص التجريبي:{" "}
                            <span
                                className="font-mono text-foreground"
                                dir="ltr"
                            >
                                استخدم بيانات دخولك الخاصة
                            </span>
                        </p>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
